import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { environment } from 'src/environments/environment';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import {Location} from "@angular/common";

@Component({
	selector: 'app-map',
	templateUrl: './map.page.html',
	styleUrls: ['map.page.scss'],
})
export class MapPage {
	customer = this.repository.customer;
	constructor(private navService: NavigationService,
				private router: Router,
				public repository: RepositoryService,
				public location: Location) {}
	static url = 'map';
	public preorderTypes = [PreorderType.TAKE_AWAY, PreorderType.DELIVERY];

	static navigate(router: Router) {
		return router.navigateByUrl(MapPage.url);
	}
	goHome() {
		this.navService.home();
	}
}
